// extracted by mini-css-extract-plugin
export default {"incrementalBtnsWrapper":"Ul8WHQ306oMl6UTLrV2x"};